import React, { useEffect } from 'react';
import { TOAST_TYPES } from '../../utils/constants';

const Toast = ({ message, type = TOAST_TYPES.INFO, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 5000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const colors = {
    [TOAST_TYPES.SUCCESS]: 'bg-green-100 text-green-800 border-green-500',
    [TOAST_TYPES.ERROR]: 'bg-red-100 text-red-800 border-red-500',
    [TOAST_TYPES.WARNING]: 'bg-yellow-100 text-yellow-800 border-yellow-500',
    [TOAST_TYPES.INFO]: 'bg-blue-100 text-blue-800 border-blue-500'
  };

  return (
    <div className={`fixed top-4 right-4 p-4 rounded-lg border-l-4 ${colors[type]} z-50 max-w-md shadow-lg`}>
      <div className="flex items-center justify-between">
        <p className="font-medium">{message}</p>
        <button onClick={onClose} className="ml-4 text-current opacity-70 hover:opacity-100">
          ×
        </button>
      </div>
    </div>
  );
};

export const ToastContainer = ({ toasts, removeToast }) => {
  return (
    <div className="fixed top-4 right-4 z-50 space-y-2">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          onClose={() => removeToast(toast.id)}
        />
      ))}
    </div>
  );
};

export default Toast;
